import { Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, withLatestFrom } from 'rxjs/operators';
import { selectAppConfig } from 'src/app/core/application-config/application-config.selectors';
import { selectMerchantId } from 'src/app/core/client-configuration/client-configuration.selectors';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { APPCONFIG_ASSET_PATH, APPCONFIG_LOGO } from 'src/app/shared/enums/application-config.enums';
import { parseFilenameForAltText } from 'src/app/shared/utilities/string.utils';
import { validString } from 'src/app/shared/utilities/types.utils';

@Component({
	selector: 'ahp-dashboard-header',
	templateUrl: './dashboard-header.component.html',
	styleUrls: ['./dashboard-header.component.scss'],
})
export class DashboardHeaderComponent {
	/**
	 * the merchant locale suffix
	 */
	@Input() merchantLocaleSuffix: string;
	/**
	 * logo path built from appConfig
	 */
	logoPath: string;
	/**
	 * logo path built from appConfig
	 */
	logoAltTag: string;

	/**
	 * unsubscribes from observables
	 */
	private _destroy$ = new Subject<void>();

	/**
	 * @param _store$ the store
	 * @param _locale the locale service
	 */
	constructor(private _store$: Store, private _locale: LocaleService) {
		this._store$
			.pipe(
				select(selectAppConfig([APPCONFIG_ASSET_PATH, APPCONFIG_LOGO])),
				withLatestFrom(this._store$.select(selectMerchantId)),
				takeUntil(this._destroy$)
			)
			.subscribe(([appConfig, merchantId]) => {
				const logoAltLocale = `accessibility.logoalttext_${merchantId}`;
				const { assetsPath, logo } = appConfig;
				if (validString(assetsPath) && validString(logo)) {
					this.logoPath = assetsPath.concat(logo);
					this.logoAltTag = this._locale.has(logoAltLocale)
						? this._locale.get(logoAltLocale)
						: parseFilenameForAltText(logo);
				}
			});
	}
}
